// DesignBackgroundEditorPage.js — FIXED VERSION
import React from "react";
import {
  Box,
  Flex,
  Heading,
  HStack,
  NumberInput,
  NumberInputField,
  Button,
  Divider,
} from "@chakra-ui/react";

import EditorCanvas from "./EditorCanvas";
import Inspector from "./Inspector";
import Controls from "./Controls";
import useEditorLogic from "./useEditorLogic";

export default function DesignBackgroundEditorPage({ backgroundId }) {
  const {
    imgUrl,
    img,

    // size controls
    viewW,
    viewH,
    setViewW,
    setViewH,
    naturalW,
    naturalH,

    // layout
    layout,
    pxLayout,
    sel,
    setSel,
    updatePct,
    toggleField,

    preview,
    setPreview,
    avatarPreviewUrl,

    currentFontSizePx,
    updateSelectedFontSizePx,
    currentWeight,
    updateSelectedWeight,
    currentColor,
    updateSelectedColor,

    handleSave,
  } = useEditorLogic(backgroundId);

  // DEFAULT DISPLAY AREA (fixed)
  const DEFAULT_W = 1080;
  const DEFAULT_H = 1620;

  const ratio = React.useMemo(() => {
  if (naturalW && naturalH) return naturalW / naturalH;
  return DEFAULT_W / DEFAULT_H; // fallback
}, [naturalW, naturalH]);

  // Khi load lần đầu → set fixed default 1080×1620
  React.useEffect(() => {
    if (!viewW && !viewH) {
      setViewW(DEFAULT_W);
      setViewH(DEFAULT_H);
    }
  }, [viewW, viewH, setViewW, setViewH]);

  return (
    <Flex direction="column" p={6} gap={4} w="100%">
      <Heading size="md">Chỉnh sửa thiết kế ảnh nền</Heading>

      {/* ================== CONTROLS BAR ================== */}
      <Box w="100%" mb={4}>
        <Controls
          layout={layout}
          preview={preview}
          setPreview={setPreview}
          toggleField={toggleField}
          handleSave={handleSave}
          direction="row"
        />
      </Box>

      {/* ================== MAIN WRAPPER ================== */}
      <Flex gap={6} align="flex-start" w="100%" overflow="hidden">

        {/* ================= LEFT AREA ================= */}
        <Box flex="1" minW="0">

          {/* SIZE CONTROLS */}
          {/* SIZE CONTROLS */}
<HStack mb={4} spacing={6}>
  <Box>
    <Box fontSize="sm" mb={1}>Chiều rộng (px)</Box>
    <NumberInput
      value={viewW}
      min={200}
      max={5000}
      onChange={(_, n) => {
        if (!Number.isFinite(n)) return;
        setViewW(n);
        setViewH(Math.round(n / ratio)); // auto scale
      }}
      w="120px"
    >
      <NumberInputField />
    </NumberInput>
  </Box>

  <Box>
    <Box fontSize="sm" mb={1}>Chiều cao (px)</Box>
    <NumberInput
      value={viewH}
      min={200}
      max={5000}
      onChange={(_, n) => {
        if (!Number.isFinite(n)) return;
        setViewH(n);
        setViewW(Math.round(n * ratio)); // auto scale
      }}
      w="120px"
    >
      <NumberInputField />
    </NumberInput>
  </Box>

  <Button
    onClick={() => {
      if (naturalW && naturalH) {
        setViewW(naturalW);
        setViewH(naturalH);
      }
    }}
  >
    Trở lại kích cỡ chuẩn {naturalW}×{naturalH}
  </Button>
</HStack>


          {/* CANVAS */}
          <Box
            borderWidth="1px"
            borderRadius="lg"
            bg="gray.200"
            overflow="auto"
            minH="300px"
            maxH={DEFAULT_H}
          >
            <EditorCanvas
              imgUrl={imgUrl}
              img={img}
              viewW={viewW}
              viewH={viewH}
              pxLayout={pxLayout}
              layout={layout}
              preview={preview}
              avatarPreviewUrl={avatarPreviewUrl}
              sel={sel}
              setSel={setSel}
              updatePct={updatePct}
            />
          </Box>

        </Box>

        {/* ================= RIGHT - INSPECTOR ================= */}
        <Box
          w="120px"
          minW="120px"
          maxW="120px"
          flexShrink={0}
        >
          <Inspector
            sel={sel}
            pxLayout={pxLayout}
            layout={layout}
            viewW={viewW}
            viewH={viewH}
            updateSelectedField={(field, value) => {
              if (!sel || !pxLayout[sel]) return;
              const next = { ...pxLayout[sel] };
              next[field] = value;
              updatePct(sel, next);
            }}
            currentFontSizePx={currentFontSizePx}
            updateSelectedFontSizePx={updateSelectedFontSizePx}
            currentWeight={currentWeight}
            updateSelectedWeight={updateSelectedWeight}
            currentColor={currentColor}
            updateSelectedColor={updateSelectedColor}
          />
        </Box>
      </Flex>

      <Divider />
    </Flex>
  );
}
